// Redux slice for offline badge: online, pendingCount, conflictCount, syncing.
export const OFFLINE_STATUS_SET = "offline_status_set";
export const OFFLINE_STATUS_PATCH = "offline_status_patch";

export const setOfflineStatus = (payload) => ({
  type: OFFLINE_STATUS_SET,
  payload,
});

export const patchOfflineStatus = (payload) => ({
  type: OFFLINE_STATUS_PATCH,
  payload,
});

const initial = {
  online: true,
  pendingCount: 0,
  conflictCount: 0,
  syncing: false,
  lastError: null,
  lastSyncedAt: null,
  pendingItems: [],
};

export function OfflineStatusReducer(state = initial, action) {
  switch (action.type) {
    case OFFLINE_STATUS_SET:
      return { ...initial, ...action.payload };
    case OFFLINE_STATUS_PATCH:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
